import React from "react";
import { Switch, Route } from "react-router-dom";
import LocationsPage from "./LocationsPage";
import LocationPage from "./LocationPage";

const Locations = () => (
  <Switch>
    <Route path="/dispatch/locations/:id">
      <LocationPage />
    </Route>
    <Route path="/dispatch/locations">
      <LocationsPage />
    </Route>
  </Switch>
);

export default Locations;
